import ServicePageTemplate from "../components/ServicePageTemplate";
import usePageMeta from "../hooks/usePageMeta";

export default function MarkAnlaggning() {
  usePageMeta({
    title: "Mark- och anläggningsarbeten i Laholm | Trädfällarna Laholm AB",
    description:
      "Mark- och anläggningsarbeten i Laholm — uppfarter, grusgångar, gräsytor och förberedande trädgårdsarbeten.",
  });

  return (
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Mark- och anläggningsarbeten"
      intro="Utöver trädfällning och trädvård hjälper vi även med markarbeten som grusgångar, uppfarter, gräsytor och förberedande trädgårdsarbeten."
      heroImage="/images/mark-anlaggning.webp"
      bodyHeading="Vi tar arbetet hela vägen"
      bodyText="Många jobb hänger ihop. När ett träd är fällt och stubben fräst återstår ofta markarbete. Vi kan sköta även den biten — från ny grusgång till förberedelse inför ny gräsmatta eller stenläggning."
      bullets={[
        "Uppfarter och grusgångar",
        "Förberedande arbete inför ny gräsmatta",
        "Markjusteringar och dräneringsarbeten",
        "Tätt samarbete med fällning och stubbfräsning",
      ]}
    />
  );
}
